// extracted by mini-css-extract-plugin
export default {"container":"BoletimSubsection_container__Zq-h6","head":"BoletimSubsection_head__o9J8U","subtitle":"BoletimSubsection_subtitle__GQRRn"};